// src/pages/VehicleManage.js
import React, { useState, useContext, useEffect } from "react";
import ReactDOM from "react-dom";
import { useNavigate, useLocation } from "react-router-dom";
import TabContext from "@/contexts/TabContext";
import { useListPageFilter, comma } from "@/utils";
import { Toast, Confirm, PageTabs, Pagination } from "@/components";
import DatePicker from "react-datepicker";
import ko from "date-fns/locale/ko";
import Select from "react-select";
import { dateFormat, dateFormatDateTime, dateFormatToISOString } from "@/utils";
import { carStatusOptions } from "@/constants/selectOptions";

import registerExcel from "@/assets/files/excel_register_sample.xlsx";
import { useGetAllCarsAdminQuery } from "../../redux/adminCarApi";

const pageFilter = {
    parameters: {
        page: 0,
        size: 20,
        query: "",
        car_status: "",
        started_at: "",
        ended_at: "",
    },
};

export const AdminVehicleManage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { state: tabs, dispatch } = useContext(TabContext);

    useEffect(() => {
        const handleTabAdd = () => {
            const existingTab = tabs.find((tab) => tab.url.split("?")[0] === location.pathname);
            if (!existingTab) {
                dispatch({
                    type: "ADD_TAB",
                    payload: { url: location.pathname + location.search, title: "차량 현황" },
                });
            }
        };

        handleTabAdd();
    }, [dispatch, location.pathname, location.search, tabs]);

    const { formData, handleChange, setFormData, parameters, toastMsg } = useListPageFilter(pageFilter, {
        confirmStatus: {
            confirmPopupStatus: false,
            confirmTitle: "",
            confirmDescription: "",
            confirmButtons: [],
        },
        vehicleExcelRegisterPopupStatus: false,
        triggerSearch: false,
    });
    const { confirmStatus, vehicleExcelRegisterPopupStatus, triggerSearch } = formData;

    const { data, error } = useGetAllCarsAdminQuery(parameters, {
        skip: !triggerSearch,
    });

    // 컴포넌트 마운트 시 초기 데이터 조회
    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            triggerSearch: true,
        }));
    }, []);

    useEffect(() => {
        console.log(formData);
    }, [formData]);

    const handleSearch = () => {
        setFormData((prev) => ({
            ...prev,
            parameters: { ...prev.parameters, page: 0 },
            triggerSearch: true,
        }));
    };

    return (
        <>
            {toastMsg && <Toast visible={true} msg={toastMsg} setFormData={setFormData} />}

            <div className="management container">
                <PageTabs />

                <div className="table-container">
                    <div className="table-head">
                        <span className="head-tit">차량 목록</span>
                        <div className="breadcrumbs">
                            <ul>
                                <li className="home"></li>
                                <li>ERP 관리</li>
                                <li>차량 목록</li>
                            </ul>
                        </div>
                    </div>
                    <TableFilter formData={formData} handleChange={handleChange} setFormData={setFormData} handleSearch={handleSearch} />

                    <div className="table-content">
                        <div className="table-option">
                            <div className="table-caption">
                                <span className="data-count">
                                    {data && data.pagination ? `전체 ${data.pagination.totalElements}건` : ""}
                                </span>
                            </div>
                            <div className="table-buttons"></div>
                        </div>

                        <div className="table-wrapper">
                            <div className="table">
                                <table>
                                    <colgroup>
                                        <col width="5%" />
                                        <col width="5%" />
                                        <col width="5%" />
                                        <col width="5%" />
                                        <col width="5%" />
                                        <col width="5%" />
                                        <col width="5%" />
                                        <col width="4%" />
                                        <col width="5%" />
                                        <col width="5%" />
                                        <col width="5%" />
                                        <col width="5%" />
                                        <col width="5%" />
                                        <col width="5%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">사업자</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">지점</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">차종</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">등급</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">차량번호</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">모델</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">상세모델</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">최초등록</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">외장색</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">주행거리</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">연료</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">보험연령</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">상태</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">관리</span>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data && data.data && data.data.length > 0 ? (
                                            data.data.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">{item.rentCorp?.corpName || ""}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">-</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">{item.carGubun}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">{item.className || "-"}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">{item.carNumber}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">{item.modelName}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">{item.modelDetailName}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">{dateFormatDateTime(item.firstDate)}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">{item.color}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">{comma(item.mileage)}km</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">{item.fuel}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">-</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-tag">
                                                                {carStatusOptions.find((e) => e.value === item.carStatus).label || ""}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <button
                                                                type="button"
                                                                className="btn-cell btn-outline"
                                                                onClick={() => navigate(`/erp/vehicle/manage/edit/${item.id}`)}
                                                            >
                                                                상세보기
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="13" className="data-empty">
                                                    <div className="cell" data-align="center">
                                                        <span className="cell-desc">데이터가 없습니다.</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {data && data.pagination && data.data.length > 0 && (
                            <Pagination pagination={data.pagination} setFormData={setFormData} />
                        )}
                    </div>
                </div>
            </div>

            {vehicleExcelRegisterPopupStatus && (
                <VehicleExcelRegisterPopup
                    layer={true}
                    onClose={() => setFormData((prev) => ({ ...prev, vehicleExcelRegisterPopupStatus: false }))}
                    formData={formData.productItemType}
                    handleChange={handleChange}
                    setFormData={setFormData}
                />
            )}
        </>
    );
};

const TableFilter = ({ formData, setFormData, handleSearch }) => {
    const { parameters } = formData;
    const [activeButton, setActiveButton] = useState(null);

    const handleParameterChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            parameters: {
                ...prev.parameters,
                [name]: value,
            },
            triggerSearch: false,
        }));
    };

    const handleDateChange = (dates, type) => {
        const [start, end] = dates;
        if (type === "create") {
            setFormData((prev) => ({
                ...prev,
                parameters: {
                    ...prev.parameters,
                    started_at: start ? dateFormatToISOString(start, "start") : "",
                    ended_at: end ? dateFormatToISOString(end, "end") : "",
                },
                triggerSearch: false,
            }));
        }
        setActiveButton(null);
    };

    const setDateRange = (days, buttonIndex) => {
        const now = new Date();
        const start = new Date(now);
        start.setDate(start.getDate() - days);
        setFormData((prev) => ({
            ...prev,
            parameters: {
                ...prev.parameters,
                page: 0,
                started_at: dateFormatToISOString(start, "start"),
                ended_at: dateFormatToISOString(now, "end"),
            },
            triggerSearch: false,
        }));
        setActiveButton(buttonIndex);
    };

    return (
        <div className="table-filter">
            <div className="filter-row">
                <div className="filter-item">
                    <div className="item-head">
                        <span className="head-tit">상태 :</span>
                    </div>
                    <div className="item-content">
                        <div className="item-select">
                            <Select
                                options={carStatusOptions}
                                className="filter-select"
                                classNamePrefix="filter-select"
                                isSearchable={false}
                                placeholder="차량상태"
                                onChange={(option) => {
                                    setFormData((prev) => ({
                                        ...prev,
                                        parameters: { ...prev.parameters, car_status: option.value },
                                        triggerSearch: false,
                                    }));
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="filter-item">
                    <div className="item-head">
                        <span className="head-tit">등록일 :</span>
                    </div>
                    <div className="item-content">
                        <div className="item-input">
                            <DatePicker
                                locale={ko}
                                showYearDropdown
                                scrollableYearDropdown
                                yearDropdownItemNumber={20}
                                dateFormat="yyyy.MM.dd"
                                onKeyDown={(e) => e.preventDefault()}
                                selectsRange={true}
                                startDate={parameters.started_at ? new Date(parameters.started_at) : null}
                                endDate={parameters.ended_at ? new Date(parameters.ended_at) : null}
                                onChange={(e) => handleDateChange(e, "create")}
                            />
                        </div>
                    </div>
                </div>
                <div className="filter-item">
                    <div className="item-content">
                        <div className="item-buttons">
                            <button
                                type="button"
                                className={`btn-toggle ${activeButton === 0 ? "active" : ""}`}
                                onClick={() => setDateRange(0, 0)}
                            >
                                당일
                            </button>
                            <button
                                type="button"
                                className={`btn-toggle ${activeButton === 15 ? "active" : ""}`}
                                onClick={() => setDateRange(15, 15)}
                            >
                                15일
                            </button>
                            <button
                                type="button"
                                className={`btn-toggle ${activeButton === 30 ? "active" : ""}`}
                                onClick={() => setDateRange(30, 30)}
                            >
                                1개월
                            </button>
                            <button
                                type="button"
                                className={`btn-toggle ${activeButton === 90 ? "active" : ""}`}
                                onClick={() => setDateRange(90, 90)}
                            >
                                3개월
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="filter-row">
                <div className="filter-item">
                    <div className="item-content">
                        <div className="item-input" style={{ width: "300px" }}>
                            <input
                                type="text"
                                placeholder="입력하세요."
                                name="query"
                                value={parameters.query}
                                onChange={handleParameterChange}
                            />
                        </div>
                        <div className="item-buttons">
                            <button type="button" className="btn-search" onClick={handleSearch}>
                                검색
                            </button>
                            <button
                                type="button"
                                className="btn-search"
                                onClick={() => {
                                    setFormData((prev) => ({
                                        ...prev,
                                        parameters: { ...pageFilter.parameters },
                                        triggerSearch: true,
                                    }));
                                }}
                            >
                                초기화
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// 차량 일괄 등록 팝업
const VehicleExcelRegisterPopup = ({ layer = true, onClose, formData, setFormData }) => {
    const navigate = useNavigate();

    const [serviceItems, setServiceItems] = useState(["TIRE_CHANGE"]);

    useEffect(() => {
        document.body.classList.add("scroll-lock");

        return () => {
            document.body.classList.remove("scroll-lock");
        };
    }, []);

    const handleConfirm = () => {
        navigate(`/vehicle/manage/register/excel`);
    };

    const downloadExcelTemplate = () => {
        const link = document.createElement("a");
        link.href = registerExcel;
        link.download = "excel_register_sample.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return ReactDOM.createPortal(
        <>
            <div className={layer ? "layer active" : "layer"} onClick={onClose}></div>

            <div className="popup excel-register-popup">
                <div className="popup-head">
                    <div className="head-tit">
                        <span className="tit-main">차량 일괄 등록</span>
                    </div>
                    <div className="btn-close" onClick={onClose}></div>
                </div>
                <div className="popup-content">
                    <div className="excel-register-guide">
                        <div className="guide-box">
                            <div className="box-head">
                                <span className="head-tit">여러대의 차량을 한번에 등록하세요.</span>
                                <span className="head-sub">엑셀 양식 다운로드부터 업로드까지 차례대로 진행해주세요.</span>
                            </div>
                            <div className="box-content">
                                <div className="process-item">
                                    <div className="item-txt">
                                        <span className="txt-main">
                                            1. 엑셀 파일을 다운받아 차량번호 및 소유주(자동차등록증상)만 입력하시면 편하게 입력 가능합니다.
                                        </span>
                                    </div>
                                    <div className="item-action">
                                        <button type="button" className="btn btn-xs btn-outline" onClick={downloadExcelTemplate}>
                                            엑셀 양식 다운로드
                                        </button>
                                    </div>
                                </div>
                                <div className="process-item">
                                    <div className="item-txt">
                                        <span className="txt-main">
                                            2. 다운로드 후 데이터를 입력한 엑셀 파일을 업로드 해주세요. 1회 업로드 최대 가능대수는 100대
                                            입니다.
                                        </span>
                                    </div>
                                </div>
                                <div className="process-item">
                                    <div className="item-txt">
                                        <span className="txt-main">
                                            3. 자동차등록증 또는 보험가입증명서 파일을 업로드 해주세요. 단, 파일명은 서류상의 자동차번호와
                                            동일하게 해주세요.
                                        </span>
                                        <span className="txt-em">예) 123하1235.jpg / 154호9876.png / 197허6598.pdf</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="guide-box">
                            <div className="box-head">
                                <span className="head-tit">FAQ</span>
                                <span className="head-sub">엑셀 파일 업로드와 차량 등록에 관한 궁금증을 모두 해결해드립니다.</span>
                            </div>
                            <div className="box-content">
                                <div className="accordian">
                                    <details>
                                        <summary>
                                            <em>Q.</em> 기존에 업로드한 차량이 있으면 어떻게 될까요?
                                        </summary>
                                        <p>{`자동차 데이터 제공업체에서 데이터 업데이트가 이뤄지지 않아, 과거의 정보가 노출 되는 현상 입니다. 
                                            국산의 경우 3~4시간 뒤 다시 조회 해보시고, 수입의 경우 1일 이후에 다시 시도 부탁드립니다. 
                                            급하신 등록 건은 고객센터로 문의 하여 주시기 바랍니다.`}</p>
                                    </details>
                                    <details>
                                        <summary>
                                            <em>Q.</em> 소유주가 일치 하지 않으면 등록이 불가한가요?
                                        </summary>
                                        <p>{`자동차 데이터 제공업체에서 데이터 업데이트가 이뤄지지 않아, 과거의 정보가 노출 되는 현상 입니다. 
                                            국산의 경우 3~4시간 뒤 다시 조회 해보시고, 수입의 경우 1일 이후에 다시 시도 부탁드립니다. 
                                            급하신 등록 건은 고객센터로 문의 하여 주시기 바랍니다.`}</p>
                                    </details>
                                    <details>
                                        <summary>
                                            <em>Q.</em> 서류가 잘못 등록 될 수도 있나요?
                                        </summary>
                                        <p>{`자동차 데이터 제공업체에서 데이터 업데이트가 이뤄지지 않아, 과거의 정보가 노출 되는 현상 입니다. 
                                            국산의 경우 3~4시간 뒤 다시 조회 해보시고, 수입의 경우 1일 이후에 다시 시도 부탁드립니다. 
                                            급하신 등록 건은 고객센터로 문의 하여 주시기 바랍니다.`}</p>
                                    </details>
                                    <details>
                                        <summary>
                                            <em>Q.</em> 차량번호 조회에 실패 했습니다.
                                        </summary>
                                        <p>{`자동차 데이터 제공업체에서 데이터 업데이트가 이뤄지지 않아, 과거의 정보가 노출 되는 현상 입니다. 
                                            국산의 경우 3~4시간 뒤 다시 조회 해보시고, 수입의 경우 1일 이후에 다시 시도 부탁드립니다. 
                                            급하신 등록 건은 고객센터로 문의 하여 주시기 바랍니다.`}</p>
                                    </details>
                                    <details>
                                        <summary>
                                            <em>Q.</em> 조회 된 차량의 데이터카 실제 차량정보와 다릅니다.
                                        </summary>
                                        <p>{`자동차 데이터 제공업체에서 데이터 업데이트가 이뤄지지 않아, 과거의 정보가 노출 되는 현상 입니다. 
                                            국산의 경우 3~4시간 뒤 다시 조회 해보시고, 수입의 경우 1일 이후에 다시 시도 부탁드립니다. 
                                            급하신 등록 건은 고객센터로 문의 하여 주시기 바랍니다.`}</p>
                                    </details>
                                    <details>
                                        <summary>
                                            <em>Q.</em> 엑셀 파일이 업로드 되지 않습니다.
                                        </summary>
                                        <p>{`자동차 데이터 제공업체에서 데이터 업데이트가 이뤄지지 않아, 과거의 정보가 노출 되는 현상 입니다. 
                                            국산의 경우 3~4시간 뒤 다시 조회 해보시고, 수입의 경우 1일 이후에 다시 시도 부탁드립니다. 
                                            급하신 등록 건은 고객센터로 문의 하여 주시기 바랍니다.`}</p>
                                    </details>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="popup-bottom">
                    <button className="btn btn-primary btn-close" onClick={handleConfirm}>
                        일괄 등록하기
                    </button>
                </div>
            </div>
        </>,
        document.body
    );
};
